import clsx from 'clsx';
import React from 'react';

type AvatarIconProps = {
  // Font Awesome class string, e.g. "fas fa-user" or "far fa-envelope"
  iconClassName: string;
  square?: boolean;
  alt?: string; // Accessible label; when omitted, icon is aria-hidden
  className?: string;
};

// AvatarIcon — styled like Avatar initials variant, but renders a centered <i> icon instead of text
export function AvatarIcon({
  iconClassName,
  square = false,
  alt = '',
  className,
  ...props
}: AvatarIconProps & React.ComponentPropsWithoutRef<'span'>) {
  return (
    <span
      data-slot="avatar"
      {...props}
      // Provide an accessible name if `alt` is set; otherwise hide from assistive tech
      role={alt ? 'img' : undefined}
      aria-label={alt ? alt : undefined}
      className={clsx(
        className,
        // Basic layout — mirror Avatar component
        'tw:inline-grid tw:shrink-0 tw:align-middle tw:[--avatar-radius:20%] tw:[--ring-opacity:20%] tw:*:col-start-1 tw:*:row-start-1',
        'tw:outline tw:outline-1 tw:-outline-offset-1 tw:outline-black/[--ring-opacity] tw:dark:outline-white/[--ring-opacity]',
        // Border radius options
        square
          ? 'tw:rounded-[--avatar-radius] tw:*:rounded-[--avatar-radius]'
          : 'tw:rounded-full tw:*:rounded-full'
      )}
    >
      <span className="tw:size-full tw:select-none tw:p-[5%] tw:flex tw:items-center tw:justify-center">
        <i
          // Use Font Awesome classes from consumer; ensure sizing and inherit color like initials
          className={clsx(iconClassName, 'tw:text-xl tw:leading-none tw:text-current')}
          aria-hidden="true"
        />
      </span>
    </span>
  );
}
